import React, { useState, useEffect } from 'react';
import BlockSetup from './BlockSetup';
import ApplicationIcon from '../../components/ApplicationIcon'
import { useTranslation } from 'react-i18next';
import { getJson } from '../../helpers/RequestsHelper'
import DragDropHelpers, { parseFields, readTextValue } from './Inputs/DragDropHelpers';
import { allActions, getLoadedActions, updateName, populateTypes } from '../../helpers/applications';

const Block = (props) => {

  const [value, setValue] = useState(props.block.label)
  const [inputTypes, setInputTypes] = useState()
  const [block, setBlock] = useState(props.block)

  const { t } = useTranslation()

  const popupId = "setup" + props.block.id
  const [showPopup, setShowPopup] = useState(sessionStorage.getItem("PopupVisible") === popupId)

  useEffect(() => {
    if (!inputTypes) {
      loadInputTypes()
    }
    if (!block.tested) {
      checkForTested()
    }
    const currentBlockParentConnections = props.workflow.connections.filter(a => a.to == props.block.id)

  });

  const onAddBlock = () => {
    props.onAddBlock(block)
  }

  const onUpdate = (newBlock, showPopup) => {
    setBlock(newBlock)
    setShowPopup(showPopup)
    props.updateBlock(newBlock)
    loadInputTypes()
    loadBlockTypes(block)
  }

  const onApplicationChange = (newApplication) => {
    // block.application = newApplication
    // delete block.action
    // delete block.params

    // props.updateBlock(newBlock)
    // loadInputTypes()
    // loadBlockTypes(block)
  }

  const onSetupClick = () => {
    loadInputTypes()
    loadBlockTypes(block)
    setShowPopup(true)
  }

  const onMergeClick = () => {
    props.setMergeMode(block)
  }

  const onConnectClick = () => {
    props.setConnectMode(block)
  }


  const loadInputTypes = () => {
    let newInputTypes = getParentBlockTypes(props.workflow, props.block, [])

    //Fill current block types
    if (props.block.action && props.block.action.inputTypes) {
      fillTypesForBlock(props.block, props.block.action.inputTypes, newInputTypes);
    }

    let stash = []
    fillStash(props.workflow, props.block.id, stash, [])
    if (stash.length > 0) {
      let stashType = {
        "id": "stash",
        "name": "Stash",
        "application": "simplyflows",
        //"blockId": parentBlock.id,
        "fields": []
      };
      for (let i = 0; i < stash.length; i++) {
        const resultField = stash[i];
        stashType.fields.push({
          "typeId": "stash",
          "id": resultField.id,
          "path": resultField.id,
          "name": resultField.name ? resultField.name : resultField.id,
          "dataType": resultField.dataType
        });
      }
      newInputTypes.push(stashType)


    }
    newInputTypes.push({
      "id": "system",
      "name": "System",
      "application": "simplyflows",
      "fields": [
        {
          "typeId": "system",
          "id": "dateNow",
          "name": "Today",
          "dataType": "date"
        },
        {
          "typeId": "system",
          "id": "dateYesterday",
          "name": "Yesterday",
          "dataType": "date"
        },
        {
          "typeId": "system",
          "id": "dateOneYearAgo",
          "name": "One year ago",
          "dataType": "date"
        },
        {
          "typeId": "system",
          "id": "timeNow",
          "name": "DateTime now",
          "description": "Date and time at the moment of execution",
          "dataType": "datetime"
        },
        {
          "typeId": "system",
          "id": "timeBeforeHour",
          "name": "Time an hour ago",
          "description": "Date and time an hour before the moment of execution",
          "dataType": "datetime"
        }
      ]
    })
    setInputTypes(newInputTypes)
  }

  const checkForTested = () => {
    if (!block.steps) {
      //TODO: Find where to put the check for app
      if ((!block.action || !block.action.steps || block.application == "simplyflows_megaverse")) {
        block.tested = true
      }
      return
    }
    const testStep = block.steps.find(a => a.type === "test");
    if (!testStep) {
      block.tested = true
    }
  }

  const loadBlockTypes = (block) => {
    let newBlockTypes = []
    fillTypes(block, newBlockTypes, true)
    block.types = newBlockTypes

    if (block.action && block.action.inputTypes) {
      let newBlockInputTypes = []
      fillTypesForBlock(block, block.action.inputTypes, newBlockInputTypes);
      block.inputTypes = newBlockInputTypes
    }
  }

  function fillStash(workflow, blockId, stash, visitedBlocks) {
    const currentBlockParentConnections = workflow.connections.filter(a => a.to == blockId);
    if (visitedBlocks.includes(blockId)) {
      return
    }
    visitedBlocks.push(blockId)
    for (let index = 0; index < currentBlockParentConnections.length; index++) {
      const parentConnection = currentBlockParentConnections[index];

      var parentBlock = workflow.blocks.find(a => a.id == parentConnection.from);

      if (parentBlock.params && parentBlock.params.stash) {
        //TODO: Make stash to support multiple 
        const stashFields = parseFields(parentBlock.params.stash.field);
        for (let j = 0; j < stashFields.length; j++) {
          const stashField = stashFields[j]
          stash.push(stashField)
        }

        const stashItems = parseFields(parentBlock.params.stash.items);
        for (let j = 0; j < stashItems.length; j++) {
          const stashItem = stashItems[j]

          //TODONOW: What about the other types? We need to get their names
          if (stashItem.typeId.startsWith("block_")) {
            var stashTypeBlock = workflow.blocks.find(a => a.id == stashItem.typeId);
            var item = stashTypeBlock.params.inputs.input["input." + stashItem.id]
            stashItem.name = item.value
          }

          stash.push(stashItem)
        }
      }

      fillStash(workflow, parentBlock.id, stash, visitedBlocks)
    }
  }

  function getParentBlockTypes(workflow, block, visitedBlocks) {
    if (visitedBlocks.includes(block.id)) {
      return
    }
    visitedBlocks.push(block.id)
    let newInputTypes = [];
    const currentBlockParentConnections = workflow.connections.filter(a => a.to == block.id);

    for (let index = 0; index < currentBlockParentConnections.length; index++) {
      const parentConnection = currentBlockParentConnections[index];

      var parentBlock = workflow.blocks.find(a => a.id == parentConnection.from);

      //TODONOW: [Google] Uncomment this to meet Google requirements
      // if (
      //   parentBlock.application && parentBlock.application.startsWith("google") && block.application &&
      //   !(
      //     (block.application.startsWith("google") || block.application.startsWith("simplyflows"))
      //   )
      // ) {
      //   newInputTypes.push({ forbidden: true, application: block.application, description: "We are working with Google to allow us to transfer data from their applications. Please let us know if that's important to you by voting below." })
      //   //Google doesn't allow us to export data to other application without certification
      //   continue
      // }

      fillTypes(parentBlock, newInputTypes);

      fillTypesForSpecificApps(workflow, parentBlock, newInputTypes, visitedBlocks);
    }
    return newInputTypes;
  }

  function fillTypes(block, newInputTypes, selfTypes) {
    if (block.action) {
      if (block.action.types) {
        fillTypesForBlock(block, block.action.types, newInputTypes);
      }
      if (block.action.customTypes) {
        block.action.customTypes.forEach(customType => {
          loadInputType(customType, block, selfTypes);
        });
      }
    }
  }


  function fillTypesForBlock(block, types, newInputTypes) {
    for (let i = 0; i < types.length; i++) {
      let type = JSON.parse(JSON.stringify(types[i]));
      //TODO: Find if we still need application
      type.application = block.application;
      type.blockId = block.id;
      if (type.id == "$export") {
        //TODO: Add type of the field
        type.fields = []
        if (block.params && block.params.fields && block.params.fields[type.fieldName]) {
          Object.entries(block.params.fields[type.fieldName]).forEach(([key, values]) => {
            type.fields.push({
              id: values.path,
              name: values.name
            })
          })
        }
      } else {
        for (let j = 0; j < type.fields.length; j++) {
          const field = type.fields[j];
          updateName(field);
          // if (field.dataType === "$ref") {
          //   field.type = parentBlock.actions.types[field.ref];
          // }
          field.typeId = type.id;
        }
      }

      const parentBlockActions = getLoadedActions(block.application);

      populateTypes(type, type, parentBlockActions.types, parentBlockActions.popularFields, "", "");

      newInputTypes.push(type);
    }
  }

  function fillTypesForSpecificApps(workflow, parentBlock, types, visitedBlocks) {
    if (parentBlock.application && parentBlock.application.startsWith("simplyflows")) {
      if (parentBlock.action.id === "merge" && parentBlock.params && parentBlock.params.merge) {
        let merge = {
          "id": "merge",
          "name": "Merge results",
          "application": parentBlock.application,
          "blockId": parentBlock.id,
          "fields": []
        };
        for (let i = 0; i < parentBlock.params.merge.length; i++) {
          const resultField = parentBlock.params.merge[i];
          merge.fields.push({
            "id": resultField.id,
            "path": resultField.id,
            "name": resultField.name,
            "dataType": resultField.dataType,
            "typeId": "merge"
          });
        }
        types.push(merge);
      }

      //We pass the parameters through these blocks, so they can be processed further
      if (parentBlock.action.id === "filter" || parentBlock.action.id === "pause" || parentBlock.action.id === "delay" || parentBlock.action.id === "continue") {
        const newTypes = getParentBlockTypes(workflow, parentBlock, visitedBlocks)
        if (newTypes) {
          for (let i = 0; i < newTypes.length; i++) {
            types.push(newTypes[i]);
          }
        }
      } else if (parentBlock.action.id === "foreach" && parentBlock.params && !parentBlock.params.items) {
        //We added support for passing a whole array accross all blocks
          const newTypes = getParentBlockTypes(workflow, parentBlock, visitedBlocks)
          if (newTypes) {
            for (let i = 0; i < newTypes.length; i++) {
              types.push(newTypes[i]);
            }
          }
      } else if (parentBlock.action.id === "foreach" && parentBlock.params && parentBlock.params.items) {
        //TODO: Error handling
        const itemsField = parseFields(parentBlock.params.items.items)[0];
        if (!itemsField) {
          const newTypes = getParentBlockTypes(workflow, parentBlock, visitedBlocks)
          if (newTypes) {
            for (let i = 0; i < newTypes.length; i++) {
              types.push(newTypes[i]);
            }
          }
          return
        }

        const grandparentConnections = workflow.connections.filter(a => a.to == parentBlock.id);
        const grandparentConnection = grandparentConnections[0];
        var grandparentBlock = workflow.blocks.find(a => a.id == grandparentConnection.from);

        const grandparentBlockActions = getLoadedActions(grandparentBlock.application)
        //TODO: Combine with others
        let type = JSON.parse(JSON.stringify(grandparentBlockActions.types[itemsField.typeId]));
        const field = type.fields.find(a => a.id == itemsField.id);
        updateName(field);
        const itemTypeId = field.items["$ref"];
        let itemType = JSON.parse(JSON.stringify(grandparentBlockActions.types[itemTypeId]));
        itemType.application = grandparentBlock.application;
        itemType.blockId = parentBlock.id//TODO:It was grandparentBlock.id;

        populateTypes(itemType, itemType, grandparentBlockActions.types, grandparentBlockActions.popularFields, "", "");

        types.push(itemType);
      } else if (parentBlock.action.id == "form" && parentBlock.params && parentBlock.params.inputs) {
        var id = parentBlock.id
        var customType = {
          id,
          "name": "Previous block",
          "fields": []
        }
        for (const [key, input] of Object.entries(parentBlock.params.inputs.input)) {
          const fieldId = key.replace("input.", "")
          customType.fields.push({
            "id": fieldId,
            "path": fieldId,
            "name": input["value"],
            "dataType": input["datatype"],
            "typeId": id
          })
        }
        //block.action.types = [customType])
        types.push(customType)
      }
    }
  }

  const loadInputType = async (info, block, selfTypes) => {
    let path = info.path
    if (!path) {
      return
    }

    const action = block.action

    let ready = true
    if (block.params && block.params["login"]) {
      if (block.params["login"].accountId) {
        path += "?accountId=" + block.params["login"].accountId
      } else {
        ready = false
      }
    }

    //TODO: Combine with the one from FlowPageInput
    if (path && info.pathParamsFromStorage) {
      let concat = path.includes('?') ? '&' : "?"
      for (let i = 0; i < info.pathParamsFromStorage.length; i++) {
        const pathParam = info.pathParamsFromStorage[i]
        if (block.params) {
          const values = block.params[pathParam.step]
          if (values) {
            if (pathParam.property) {
              path = path + concat + pathParam.name + '=' + encodeURIComponent(values[pathParam.property])
            } else {
              path = path + concat + pathParam.name + '=' + encodeURIComponent(values)
            }
            concat = "&"
          } else {
            ready = false
          }
        } else {
          ready = false
        }
        // const pathParam = info.pathParamsFromStorage[i]
        // const sessionValue = sessionStorage.getItem(FlowPage.getKey(action.id, pathParam.step))
        // if (sessionValue && sessionValue !== "undefined") {
        //   const values = JSON.parse(sessionValue)
        //   if (pathParam.property) {
        //     path = path + concat + pathParam.name + '=' + values[pathParam.property]
        //   } else {
        //     path = path + concat + pathParam.name + '=' + values
        //   }
        //   concat = "&"
        // } else {
        //   ready = false
        // }
      }
    }

    if (ready) {
      const types = await getJson(process.env.REACT_APP_SERVER_BASE_URL + path)
      if (types.error) {

      } else {
        let newInputTypes = inputTypes ? [...inputTypes] : []
        types.forEach(type => {
          if (!newInputTypes.find(a => a.blockId === action.id)) {
            //TODO: Find if we still need application
            //TODO: Combine with the previous
            type.application = block.application
            type.blockId = action.id
            for (let j = 0; j < type.fields.length; j++) {
              let field = type.fields[j]
              field.typeId = type.id
            }
            newInputTypes.push(type);
          }
        })

        //block.processed = true
        if (!selfTypes) { //TODO: We don't need this parameter if we set the input types somewhere else
          setInputTypes(newInputTypes)
        }
      }
    }
  }


  const drag = (e) => {
    e.dataTransfer.setData("id", e.target.id);
    e.dataTransfer.setData("startX", e.clientX);
    e.dataTransfer.setData("startY", e.clientY);
  }

  const getBlockTitle = () => {
    if (block.application === "simplyflows_filter") {

      var text = ""
      if (block.params && block.params.fields && block.params.fields.rules) {
        const values = Object.values(block.params.fields.rules)
        if (values.length > 0) {
          for (let index = 0; index < 1; index++) {
            const rule = values[index];
            if (rule && rule.field && rule.field.field) {
              const fields = parseFields(rule.field.field)
              if (fields && fields.length > 0) {
                const field = fields[0]
                updateName(field)
                if (text !== "") {
                  if (block.params.fields.conjunction === "or") {
                    text += " or "
                  } else {
                    text += " and "
                  }
                }

                var value = (rule.value ? "" + rule.value : "")
                if (value.length > 20) {
                  value = value.substring(0, 20) + "... "
                }

                text += field.name + getOperatorName(rule.operator) + (rule.operator === "changed" ? "" : value)

                if (values.length > 1) {
                  text += " ... ("
                  if (block.params.fields.conjunction === "or") {
                    text += "or "
                  } else {
                    text += "and "
                  }
                  text += (values.length - 1) + " more rules) "
                }
              }
            }
          }
        }
      }
      block.label = text === "" ? "Filter" : "When " + text

      return block.label
    }
    else if (block.application === "simplyflows_sendemail") {
      var text = ""
      if (inputTypes && block.params && block.params.subject) {
        text = readTextValue(block.params.subject, inputTypes, false)
      }
      block.label = text === "" ? "Receive Email" : "Receive email '" + text + "'"

      return block.label
    }
    else if (block.application === "simplyflows_sms") {
      var text = ""
      if (inputTypes && block.params && block.params.text) {
        text = readTextValue(block.params.text, inputTypes, false)
      }
      block.label = text === "" ? "Receive a message" : "Receive a message '" + text + "'"

      return block.label
    }
    else if (block.application === "simplyflows_crypto") {
      if (block.action) {
        if (block.action.id === "maketrade") {
          block.label = "New trade recommendation for " + ((block.params && block.params.fields) ? block.params.fields.currency : "")
        } else {
          block.label = block.action.name
        }
      }

      return block.label
    }
    else if (block.application === "simplyflows_schedule") {
      if (block.action && block.action.id === "schedule") {
        //TODO: Constant
        block.label = block.params && block.params.cron ? block.params.cron.text : "Every 15 minutes"
      } else {
        block.label = "Every 15 minutes"
      }

      return block.label
    }
    else if (block.application === "simplyflows_megaverse") {
      if (block.action) {
        block.label = block.action.name
        if (block.params && block.params.fields) {
          const fields = block.params.fields
          if (fields.dialog) {
            block.label += ": " + fields.dialog
          }
          // return <>{fields.visitor ? <><b>V:</b> {fields.visitor}<br/></> : ""}
          // {fields.assistant ?<><b>A:</b> {fields.assistant}<br/></> : ""}</>

        }
      }

      return block.label
    }
    else {
      return block.action ? block.action.name : ""
    }
  }

  //TODO: Move in some utility
  const getOperatorName = (operator) => {
    switch (operator) {
      case "eq":
        return " is equal to "
      case "ne":
        return " is not equal to "
      case "ge":
        return " is greater than or equal to "
      case "gt":
        return " is greater than "
      case "le":
        return " is less than or equal to "
      case "lt":
        return " is less than "
      case "contains":
        return " contains "
      case "currentweek":
        return " is in the current week "
      case "currentmonth":
        return " is in the current month "
      case "lastweek":
        return " is in the last week "
      case "lastmonth":
        return " is in the last month "
      case "changed":
        return " has changed "

      default:
        return "";
    }
  }

  let content

  switch (block.type) {
    case "start":
    case "application": content =
      <table className="">
        <tbody>
          <tr><td width="32">
            <div className="workflow-block-icon">
              <ApplicationIcon onlyIcon="true" appType={block.application} />
            </div>
          </td><td>
              {getBlockTitle()}</td>
          </tr>
        </tbody>
      </table>
      break
    case "input":
    case undefined: content =
      <input type="text"
        className="form-control"
        autoFocus={props.focusedBlock && props.focusedBlock.id == block.id}
        onBlur={(e) => { if (e.target.value.length > 0) { block.label = value; block.type = "text"; props.updateBlock(block) } }}
        onChange={(e) => { setValue(e.target.value); block.label = e.target.value; block.tested = true; props.updateBlock(block) }}
        value={value}
        onKeyDown={(e) => { if (e.keyCode === 13) { block.label = value; block.type = "text"; onAddBlock() } }} />
      break
    default: content =
      <div onClick={(e) => { block.type = "input"; props.updateBlock(block) }}>
        <label>{block.label}</label>
      </div>
      break
  }

  return <div>
    <div className="workflow-block" id={block.id} draggable="true" onDragStart={drag} key={block.id + block.top + block.left}>
      <button className="icon-button workflow-setup-button" onClick={onSetupClick} title={t("tip_block_setup")}><i className="fas fa-ellipsis-h"></i></button>
      {props.mergeBlocks && props.mergeBlocks.length > 0 ? <button className="icon-button workflow-add-merge-button" title={t("tip_block_merge")} onClick={onMergeClick}><i className="fas fa-plug"></i></button> : ""}
      {block.tested ? "" : <button className="icon-button workflow-warning-button" title={t("tip_block_warning")} onClick={onSetupClick} ><i className="fas fa-exclamation"></i></button>}
      {showPopup ? <BlockSetup popupId={popupId} block={block} onUpdate={onUpdate} onApplicationChange={onApplicationChange} onDelete={props.onDeleteBlock} show={showPopup} inputTypes={inputTypes} workflow={props.workflow} loadBlockTypes={loadBlockTypes} isLegacy={props.isLegacy} /> : ""}
      {content}
    </div>
    <button onClick={onAddBlock} className="icon-button workflow-add-button" title={t("tip_block_add")}><i className="fas fa-plus"></i></button>
    {/* Commenting for now as we find the feature very confusing <button onClick={onConnectClick} className="icon-button workflow-connect-button" title={t("tip_block_connect")}><i className="fas fa-external-link-alt"></i></button> */}
  </div >
}

export default Block


